<template>
  <div class="field">
    <div class="label">{{ label }} {{ isRequired ? ' *' : '' }}</div>
    <div class="control"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'Field',
  props: {
    label: String,
    isRequired: {
      type: Boolean,
      default: false
    }
  }
};
</script>
